export const COMPANY_GROUP_NAME = 'societe';
